import { createRouter, createWebHistory } from 'vue-router'
import SessionView from '../views/SessionView.vue'
import ReportView from '../views/ReportView.vue'
import NotFound from '../views/NotFound.vue'

const routes = [
  {
    // Token doğrulama səhifəsi - web app Session.vue ilə eyni davranış
    path: '/session/:token',
    name: 'session',
    component: SessionView,
    props: true
  },
  {
    // Ana hesabat səhifəsi - token URL-də olmur, localStorage-dan oxunur
    path: '/',
    name: 'report',
    component: ReportView
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
